import React, { memo, ReactElement, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { Hint, TextInputField } from '@bucketplace/commerce-admin-ui';

import { FormContent, InspectorFormProvider, LogDataFormGroup } from '../../../components';
import { useLinkContext } from '../../../contexts';
import { DocumentInspectorProps, DocumentNode } from '../../../types';
import { ImageMapBrazeProps } from './ImageMapBraze';

export function ImageMapBrazeInspector({
  value,
  onChange,
}: DocumentInspectorProps<ImageMapBrazeProps>) {
  return (
    <InspectorFormProvider value={value} onChange={onChange}>
      <ImageMapBrazeForm value={value} />
      <LogDataInput value={value} />
    </InspectorFormProvider>
  );
}

function ImageMapBrazeForm({ value }: { value: DocumentNode<ImageMapBrazeProps> }): ReactElement {
  const { setValue } = useFormContext();
  const { style } = value?.props ?? {};

  useEffect(() => {
    setValue('style', style);
  }, [style, setValue]);

  return (
    <>
      <FormContent header="Braze 커스텀 이벤트 이름" required>
        <TextInputField
          name="customEventName"
          width="100%"
        />
        <Hint error>Braze로 적재할 이벤트명을 입력해주세요. 빈 칸일경우 이벤트가 적재되지 않습니다.</Hint>
      </FormContent>
      <FormContent header="URL">
        <TextInputField
          name="url"
          width="100%"
        />
      </FormContent>
      <FormContent header="URL 미입력 시 나오는 토스트 메세지">
        <TextInputField
          name="message"
          width="100%"
        />
      </FormContent>
    </>
  );
}

const LogDataInput = memo(({ value }: { value: DocumentNode<ImageMapBrazeProps> }): ReactElement => {
  const { setLogData } = useLinkContext();
  const { children, ...others } = value ?? {};

  return (
    <LogDataFormGroup
      nodeKey={value?.key}
      {...setLogData?.({
        ...others,
        props: {
          logData: value?.props?.logData,
        },
      })}
    />
  );
});
